import React from 'react';
import PropTypes from 'prop-types';

import { DODGER_BLUE } from '@constant/colors';

const Arrow = ({ className, color, onClick, orientation, thickness }) => (
  <svg
    className={`arrow-icon--${orientation} ${className}`}
    onClick={onClick}
    viewBox="-1 14 9 12"
  >
    <path
      stroke={color}
      strokeWidth={thickness}
      d="M5 15l-5 5 5 5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Arrow.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  orientation: PropTypes.string,
  thickness: PropTypes.number,
};

Arrow.defaultProps = {
  className: '',
  color: DODGER_BLUE,
  orientation: 'left',
  thickness: 2,
};

export default Arrow;
